module.exports = __webpack_public_path__ + "cc9758df8325d515d43cd438ce8faa6e.jpg";